// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2ZpMa","vLegacy":"SelectSecondary_vLegacy__38Nqu","error":"SelectSecondary_error__141jo","disabled":"SelectSecondary_disabled__3C8DF"};